import wellsFargoLogo from "images/logos/wells-fargo-logo.png";
import enterpriseLogo from "images/logos/enterprise-logo.png";
import { PDFDownloadLink, Text, View } from "@react-pdf/renderer";
import { ApplicationFormPDFDownload } from "features/ApplicationForm/Components/ApplicationFormPDFDownload";
import { useApplicationFormContext } from "features/ApplicationForm/ApplicationFormProvider";

const FBDICourse = () => {
  const { data } = useApplicationFormContext();
  return (
    <div className="col-span-12 flex flex-col justify-between items-center my-10 gap-10">
      <div className="flex flex-col justify-center items-center gap-10">
        <p className="text-xl text-center w-2/3">{`Thank you for your interest in the Faith-Based Development Initiative, an Enterprise Community Partners program.`}</p>
        <p className="text-secondaryColor-normal">
          You will receive an invitation email once your account has been
          approved to access the Faith-Based Development Guide.
        </p>
      </div>
      {/* <div className='w-full flex flex-row-reverse justify-center'>
        <PDFDownloadLink
          fileName='Faith-Based_Development_Guide_2023'
          document={<ApplicationFormPDFDownload data={data} />}
        >
          {({ loading, error }) => {
            return loading ? (
              <View>
                <Text>Loading</Text>
              </View>
            ) : (
              <View>
                <Text
                  style={{
                    textDecoration: 'underline',
                    color: '#8B5CF6',
                    fontSize: 24,
                    fontWeight: 'bold',
                  }}
                >
                  DOWNLOAD YOUR LESSON PLAN
                </Text>
              </View>
            );
          }}
        </PDFDownloadLink>
      </div> */}

      <a
        href="https://assets.seinterminal.com/files/FBDG_Lesson_Plan-Multifamily_New_Construction-July_2023.pdf"
        target="_blank"
        rel="noreferrer noopener"
      >
        <h1 className="text-purple-500 font-bold underline">
          DOWNLOAD YOUR LESSON PLAN
        </h1>
      </a>
      <div className="flex items-center gap-5">
        <img src={enterpriseLogo} alt="Enterprise Logo" />
        <img
          src={wellsFargoLogo}
          alt="Wells Fargo Logo"
          className="object-sale-down w-16"
        />
      </div>
    </div>
  );
};

export default FBDICourse;
